/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refund_Err_Amount_RequiredInputs */

const vi_refund_err_amount_required = /** @type {(inputs: Refund_Err_Amount_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số tiền hoàn lớn hơn 0`)
};

/**

* @param {Refund_Err_Amount_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_err_amount_required = /** @type {((inputs?: Refund_Err_Amount_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_Err_Amount_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_err_amount_required(inputs)
});